// extracted by css-extract-rspack-plugin
export default {"disclaimer":"FoA01mn___disclaimer","footer":"njnU7RK___footer","subtitle":"bq8otjG___subtitle"};